import { notification } from 'antd';
import { applyBellSchedule, type BellSchedule } from 'services/api';

interface UseBellScheduleApplyProps {
  bellSchedule: BellSchedule;
  refreshTable: () => void;
}

export const useBellScheduleApply = ({ bellSchedule, refreshTable }: UseBellScheduleApplyProps) => {
  const handleApplyBellSchedule = async () => {
    await applyBellSchedule(bellSchedule.id).then(() => {
      notification.success({
        message: 'Успешно',
        description: 'Расписание звонков применено',
        duration: 1,
      });
      refreshTable();
    });
  };

  return {
    methods: { handleApplyBellSchedule },
  };
};
